// react
import React from "react";

// components
import Icon from "../../../components/Icon";

import PropTypes from "../../../lib/prop-types";

// config
import Config from "../config";

export default class ToastNotification extends React.PureComponent {
	static propTypes = {
		style: PropTypes.object,
		message: PropTypes.string,
		actionCTA: PropTypes.string,
		action: PropTypes.func.isRequired,
		remove: PropTypes.func.isRequired,
	};

	static defaultProps = {
		style: {},
		message: "",
		actionCTA: "View",
	};

	handleClick = () => {
		this.props.action();
	};

	handleRemove = () => {
		this.props.remove();
	};

	render() {
		const { message, style, actionCTA } = this.props;

		return (
			<section style={{ width: Config.get("width"), ...style }} className="notification-box type-toast">
				<div className="inner-wrapper">
					<div>
						<div className="message">{message}</div>
						<div className="action" onClick={this.handleClick}>
							{actionCTA}
						</div>
					</div>
				</div>

				<div onClick={this.handleRemove} className="close-notification">
					<Icon type="fa5" size={14} name={["fas", "times"]} />
				</div>
			</section>
		);
	}
}
